export default class extends HTMLElement {

  constructor() {
    super();

    const shadow = this.attachShadow({mode: 'open'});
    const text = this.getAttribute('text');
    const iconUrl = this.getAttribute('icon') ?? theme.settings.badgeIcon;

    if(!text) return;

    const wrapper = document.createElement('span');
    wrapper.classList.add('badge-wrapper');

    const span = document.createElement('span');
    span.classList.add('text');
    span.innerText = text;

    const style = document.createElement('style');
    style.textContent = `
      .badge-wrapper {
        position: relative;
        display: grid;
        place-items: center;
        width: var(--badgeSize);
        height: var(--badgeSize);
        transform-origin: center;
        transform-style: preserve-3D;

        background-color: var(--badgeColor, #EC6D47);
        -webkit-mask-image: url(${iconUrl});
        mask-image: url(${iconUrl});
        -webkit-mask-size: contain;
        mask-size: contain;
      }

      .text {
        font-size: var(--fontSize, 12px);
        font-weight: 500;
        text-align: center;
        line-height: 1.1;
        color: var(--textColor, currentColor);
        transform: rotate(var(--degree, 0));
        z-index: 2;
        padding: 4px 4px 0;
      }
    `;

    //wrapper.appendChild(img);
    wrapper.appendChild(span);
    shadow.append(style, wrapper);
  }
}